import { GET_USER_PERMISSIONS} from './../constants';
import { handleActions } from "redux-actions"

export const userPermissions = handleActions(
  { 
    [ GET_USER_PERMISSIONS ]: (state, action) => action.payload,
  }, []
)